export default function useWishlistService() {
  const lastError = ref<any>(null);
  const isLoading = ref(false);

  const fetchWishlist = async () => {
    isLoading.value = true;
    lastError.value = null;
    try {
      const res = await $fetch('/api/centra/wishlist');
      return res;
    } catch (e: any) {
      console.error('[useWishlistService] fetchWishlist error:', e);
      
      // If wishlist feature is not enabled or no wishlist exists, treat as empty
      if (e.statusCode === 404 || e.status === 404) {
        return { items: [] };
      }
      
      lastError.value = e;
      return null;
    } finally {
      isLoading.value = false;
    }
  };

  const addItemToWishlist = async (item: string) => {
    isLoading.value = true;
    lastError.value = null;
    try {
      const res = await $fetch('/api/centra/wishlist/items', {
        method: 'POST',
        body: { item },
      });
      return res;
    } catch (e: any) {
      console.error('[useWishlistService] addItemToWishlist error:', e);
      lastError.value = e;
      return null;
    } finally {
      isLoading.value = false;
    }
  };

  const removeItemFromWishlist = async (lineId: string) => {
    isLoading.value = true;
    lastError.value = null;
    try {
      const res = await $fetch(`/api/centra/wishlist/items/${encodeURIComponent(lineId)}`, {
        method: 'DELETE',
      });
      return res;
    } catch (e: any) {
      console.error('[useWishlistService] removeItemFromWishlist error:', e);
      lastError.value = e;
      return null;
    } finally {
      isLoading.value = false;
    }
  };

  return {
    fetchWishlist,
    addItemToWishlist,
    removeItemFromWishlist,
    isLoading,
    lastError,
  };
}
